// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  touch-action: manipulation;
}

body {
  touch-action: manipulation;
  zoom: 1 !important;
}

.programas {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff5f0 100%);
  padding: 80px 20px;
}

.programas .section-title {
  margin-bottom: 14px;
}

.programas .section-subtitle {
  margin-bottom: 10px;
  max-width: 911px;
  padding: 0 8px;
  box-sizing: border-box;
}

.programas .section-subtitle:last-of-type {
  margin-bottom: 28px;
}

.section-subtitle {
  font-size: 1.1em;
  color: #666;
  margin-bottom: 60px;
  text-align: justify;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 35px;
  max-width: 1300px;
  margin: 40px auto 0;
}

/* Cuando un programa está expandido, solo ocupa una columna (todo el ancho) */
.grid .programa-card.expandido {
  grid-column: 1 / -1;
}

.programa-card {
  background: white;
  border-top: 5px solid #FF8C00;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  position: relative;
  text-align: left;
  display: flex;
  flex-direction: column;
  min-height: 280px;
}

.programa-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(255, 140, 0, 0.15);
}

.programa-card.expandido {
  transform: none;
  box-shadow: 0 25px 70px rgba(255, 140, 0, 0.2);
  padding: 45px;
  cursor: default;
}

.programa-card.expandido:hover {
  transform: none;
}

.programa-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 25px;
  gap: 20px;
}

.programa-titulo-grupo h3 {
  font-size: 1.6em;
  margin: 0 0 8px 0;
  color: #FF8C00 !important;
  font-family: 'Playfair Display', serif;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.programa-titulo-grupo .subtitulo {
  font-size: 0.95em;
  color: #FF8C00;
  margin: 0;
  font-weight: 500;
  text-align: justify;
}

.programa-logo {
  font-size: 2.2em;
  font-weight: 800;
  color: #5B4B8A;
  font-family: 'Poppins', sans-serif;
  flex-shrink: 0;
  width: auto;
  min-width: 80px;
  text-align: center;
  letter-spacing: -0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.programa-logo img {
  height: 68px;
  width: auto;
  object-fit: contain;
}

.programa-card-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  position: relative;
  z-index: 2;
}

.programa-card-logo img {
  height: 304px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.12));
}

.programa-contenido {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-bottom: 25px;
}

.programa-columna-izquierda {
  display: flex;
  flex-direction: column;
}

.programa-columna-derecha {
  display: flex;
  align-items: center;
}

.detalles-texto {
  color: #666;
  line-height: 1.7;
  margin-bottom: 20px;
  font-size: 0.98em;
  text-align: left;
}

.programa-card .objetivos {
  margin-top: 20px;
}

.programa-card .objetivos h4 {
  font-size: 1.05em;
  font-family: 'Playfair Display', serif;
  color: #333;
  margin: 0 0 15px 0;
  border-left: 3px solid #FF8C00;
  padding-left: 12px;
  font-weight: 700;
}

.programa-card .objetivos ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.programa-card .objetivos li {
  padding: 8px 0;
  padding-left: 25px;
  position: relative;
  color: #666;
  font-size: 0.93em;
  line-height: 1.5;
}

.programa-card .objetivos li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #FF8C00;
  font-weight: bold;
  font-size: 1.1em;
}

.programa-galeria {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  width: 100%;
}

.programa-galeria img {
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 8px;
  background: #f0f0f0;
  border: 3px solid #FF8C00;
  display: block;
  box-sizing: border-box;
  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.15);
  transition: all 0.3s ease;
}

.programa-card.expandido .programa-galeria img {
  animation: floatImage 3s ease-in-out infinite;
}

.programa-galeria img:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(255, 140, 0, 0.25);
}

.programa-card.expandido .programa-galeria img:hover {
  animation-play-state: paused;
  transform: translateY(-8px);
}

@keyframes floatImage {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-4px); }
}

.programa-galeria img:nth-child(3) {
  grid-column: 1 / -1;
  max-width: 100%;
  aspect-ratio: 2 / 1;
}

.programa-galeria img.programa2-foto2-ajustada {
  object-position: center 20% !important;
}

.programa-galeria img.programa2-foto3-ajustada {
  object-position: 75% 20% !important;
}

.programa-galeria img.programa1-foto3-ajustada {
  object-position: center 30% !important;
}

.programa-card::after {
  content: '';
  position: absolute;
  bottom: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 140, 0, 0.05) 0%, rgba(91, 75, 138, 0.05) 100%);
  transition: bottom 0.5s ease;
  z-index: 0;
}

.programa-card:hover {
  border-top-color: #5B4B8A;
  background: white;
  transform: translateY(-18px) scale(1.03);
  box-shadow: 0 30px 60px rgba(255, 140, 0, 0.25);
}

.programa-card:hover::after {
  bottom: 0;
}

.programa-card h3 {
  font-size: 1.5em;
  font-family: 'Playfair Display', serif;
  font-weight: 700;
  margin: 0 0 10px 0;
  letter-spacing: 0.3px;
  color: #FF8C00;
}

.programa-card .subtitulo {
  color: #5B4B8A;
  font-weight: 600;
  margin: 0 0 15px 0;
  font-size: 0.95em;
  font-family: 'Lora', serif;
  font-style: italic;
  text-align: left;
}

.programa-card > p:not(.subtitulo) {
  color: #666;
  line-height: 1.6;
  margin: 0 0 20px 0;
  flex-grow: 1;
  font-size: 0.95em;
}

.programa-card .btn {
  margin-top: auto;
  cursor: pointer;
  position: relative;
  z-index: 10;
  pointer-events: auto;
}


@media (max-width: 1024px) {
  .programa-contenido {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .programa-galeria {
    grid-template-columns: repeat(2, 1fr);
  }

  .programa-header {
    flex-direction: column;
  }

  .programa-logo {
    margin-top: 15px;
  }
}

@media (max-width: 900px) {
  .programa-contenido {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .programa-card.expandido {
    padding: 25px;
  }

  .programa-titulo-grupo h3 {
    font-size: 1.4em;
  }

  .programa-logo {
    font-size: 2em;
  }

  .programa-logo img {
    height: 58px;
  }

  .programa-card-logo img {
    height: 248px;
  }

  .programa-contenido {
    gap: 20px;
  }

  .programa-galeria {
    grid-template-columns: 1fr;
  }

  .programa-galeria img {
    aspect-ratio: 16 / 9;
  }

  .programa-galeria img:nth-child(3) {
    aspect-ratio: 16 / 9;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Programas.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oDAAoD;EACpD,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6FAA6F;EAC7F,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;;AAGA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["html {\r\n  touch-action: manipulation;\r\n}\r\n\r\nbody {\r\n  touch-action: manipulation;\r\n  zoom: 1 !important;\r\n}\r\n\r\n.programas {\r\n  background: linear-gradient(135deg, #f8f9fa 0%, #fff5f0 100%);\r\n  padding: 80px 20px;\r\n}\r\n\r\n.programas .section-title {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.programas .section-subtitle {\r\n  margin-bottom: 10px;\r\n  max-width: 911px;\r\n  padding: 0 8px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.programas .section-subtitle:last-of-type {\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.section-subtitle {\r\n  font-size: 1.1em;\r\n  color: #666;\r\n  margin-bottom: 60px;\r\n  text-align: justify;\r\n  font-family: 'Poppins', sans-serif;\r\n  font-weight: 400;\r\n  max-width: 700px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  line-height: 1.6;\r\n}\r\n\r\n.grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 35px;\r\n  max-width: 1300px;\r\n  margin: 40px auto 0;\r\n}\r\n\r\n/* Cuando un programa está expandido, solo ocupa una columna (todo el ancho) */\r\n.grid .programa-card.expandido {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.programa-card {\r\n  background: white;\r\n  border-top: 5px solid #FF8C00;\r\n  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);\r\n  border-radius: 12px;\r\n  padding: 30px;\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\r\n  cursor: pointer;\r\n  position: relative;\r\n  text-align: left;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 280px;\r\n}\r\n\r\n.programa-card:hover {\r\n  transform: translateY(-8px);\r\n  box-shadow: 0 15px 40px rgba(255, 140, 0, 0.15);\r\n}\r\n\r\n.programa-card.expandido {\r\n  transform: none;\r\n  box-shadow: 0 25px 70px rgba(255, 140, 0, 0.2);\r\n  padding: 45px;\r\n  cursor: default;\r\n}\r\n\r\n.programa-card.expandido:hover {\r\n  transform: none;\r\n}\r\n\r\n.programa-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 25px;\r\n  gap: 20px;\r\n}\r\n\r\n.programa-titulo-grupo h3 {\r\n  font-size: 1.6em;\r\n  margin: 0 0 8px 0;\r\n  color: #FF8C00 !important;\r\n  font-family: 'Playfair Display', serif;\r\n  font-weight: 800;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.programa-titulo-grupo .subtitulo {\r\n  font-size: 0.95em;\r\n  color: #FF8C00;\r\n  margin: 0;\r\n  font-weight: 500;\r\n  text-align: justify;\r\n}\r\n\r\n.programa-logo {\r\n  font-size: 2.2em;\r\n  font-weight: 800;\r\n  color: #5B4B8A;\r\n  font-family: 'Poppins', sans-serif;\r\n  flex-shrink: 0;\r\n  width: auto;\r\n  min-width: 80px;\r\n  text-align: center;\r\n  letter-spacing: -0.5px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.programa-logo img {\r\n  height: 68px;\r\n  width: auto;\r\n  object-fit: contain;\r\n}\r\n\r\n.programa-card-logo {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 16px;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.programa-card-logo img {\r\n  height: 304px;\r\n  width: auto;\r\n  object-fit: contain;\r\n  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.12));\r\n}\r\n\r\n.programa-contenido {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 40px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.programa-columna-izquierda {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.programa-columna-derecha {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.detalles-texto {\r\n  color: #666;\r\n  line-height: 1.7;\r\n  margin-bottom: 20px;\r\n  font-size: 0.98em;\r\n  text-align: left;\r\n}\r\n\r\n.programa-card .objetivos {\r\n  margin-top: 20px;\r\n}\r\n\r\n.programa-card .objetivos h4 {\r\n  font-size: 1.05em;\r\n  font-family: 'Playfair Display', serif;\r\n  color: #333;\r\n  margin: 0 0 15px 0;\r\n  border-left: 3px solid #FF8C00;\r\n  padding-left: 12px;\r\n  font-weight: 700;\r\n}\r\n\r\n.programa-card .objetivos ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.programa-card .objetivos li {\r\n  padding: 8px 0;\r\n  padding-left: 25px;\r\n  position: relative;\r\n  color: #666;\r\n  font-size: 0.93em;\r\n  line-height: 1.5;\r\n}\r\n\r\n.programa-card .objetivos li::before {\r\n  content: '✓';\r\n  position: absolute;\r\n  left: 0;\r\n  color: #FF8C00;\r\n  font-weight: bold;\r\n  font-size: 1.1em;\r\n}\r\n\r\n.programa-galeria {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 15px;\r\n  width: 100%;\r\n}\r\n\r\n.programa-galeria img {\r\n  width: 100%;\r\n  height: auto;\r\n  aspect-ratio: 1;\r\n  object-fit: cover;\r\n  border-radius: 8px;\r\n  background: #f0f0f0;\r\n  border: 3px solid #FF8C00;\r\n  display: block;\r\n  box-sizing: border-box;\r\n  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.15);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.programa-card.expandido .programa-galeria img {\r\n  animation: floatImage 3s ease-in-out infinite;\r\n}\r\n\r\n.programa-galeria img:hover {\r\n  transform: translateY(-8px);\r\n  box-shadow: 0 12px 24px rgba(255, 140, 0, 0.25);\r\n}\r\n\r\n.programa-card.expandido .programa-galeria img:hover {\r\n  animation-play-state: paused;\r\n  transform: translateY(-8px);\r\n}\r\n\r\n@keyframes floatImage {\r\n  0%, 100% { transform: translateY(0px); }\r\n  50% { transform: translateY(-4px); }\r\n}\r\n\r\n.programa-galeria img:nth-child(3) {\r\n  grid-column: 1 / -1;\r\n  max-width: 100%;\r\n  aspect-ratio: 2 / 1;\r\n}\r\n\r\n.programa-galeria img.programa2-foto2-ajustada {\r\n  object-position: center 20% !important;\r\n}\r\n\r\n.programa-galeria img.programa2-foto3-ajustada {\r\n  object-position: 75% 20% !important;\r\n}\r\n\r\n.programa-galeria img.programa1-foto3-ajustada {\r\n  object-position: center 30% !important;\r\n}\r\n\r\n.programa-card::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -100%;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(135deg, rgba(255, 140, 0, 0.05) 0%, rgba(91, 75, 138, 0.05) 100%);\r\n  transition: bottom 0.5s ease;\r\n  z-index: 0;\r\n}\r\n\r\n.programa-card:hover {\r\n  border-top-color: #5B4B8A;\r\n  background: white;\r\n  transform: translateY(-18px) scale(1.03);\r\n  box-shadow: 0 30px 60px rgba(255, 140, 0, 0.25);\r\n}\r\n\r\n.programa-card:hover::after {\r\n  bottom: 0;\r\n}\r\n\r\n.programa-card h3 {\r\n  font-size: 1.5em;\r\n  font-family: 'Playfair Display', serif;\r\n  font-weight: 700;\r\n  margin: 0 0 10px 0;\r\n  letter-spacing: 0.3px;\r\n  color: #FF8C00;\r\n}\r\n\r\n.programa-card .subtitulo {\r\n  color: #5B4B8A;\r\n  font-weight: 600;\r\n  margin: 0 0 15px 0;\r\n  font-size: 0.95em;\r\n  font-family: 'Lora', serif;\r\n  font-style: italic;\r\n  text-align: left;\r\n}\r\n\r\n.programa-card > p:not(.subtitulo) {\r\n  color: #666;\r\n  line-height: 1.6;\r\n  margin: 0 0 20px 0;\r\n  flex-grow: 1;\r\n  font-size: 0.95em;\r\n}\r\n\r\n.programa-card .btn {\r\n  margin-top: auto;\r\n  cursor: pointer;\r\n  position: relative;\r\n  z-index: 10;\r\n  pointer-events: auto;\r\n}\r\n\r\n\r\n@media (max-width: 1024px) {\r\n  .programa-contenido {\r\n    grid-template-columns: 1fr;\r\n    gap: 30px;\r\n  }\r\n\r\n  .programa-galeria {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .programa-header {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .programa-logo {\r\n    margin-top: 15px;\r\n  }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .programa-contenido {\r\n    grid-template-columns: 1fr;\r\n    gap: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 20px;\r\n  }\r\n\r\n  .programa-card.expandido {\r\n    padding: 25px;\r\n  }\r\n\r\n  .programa-titulo-grupo h3 {\r\n    font-size: 1.4em;\r\n  }\r\n\r\n  .programa-logo {\r\n    font-size: 2em;\r\n  }\r\n\r\n  .programa-logo img {\r\n    height: 58px;\r\n  }\r\n\r\n  .programa-card-logo img {\r\n    height: 248px;\r\n  }\r\n\r\n  .programa-contenido {\r\n    gap: 20px;\r\n  }\r\n\r\n  .programa-galeria {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .programa-galeria img {\r\n    aspect-ratio: 16 / 9;\r\n  }\r\n\r\n  .programa-galeria img:nth-child(3) {\r\n    aspect-ratio: 16 / 9;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
